import { Link } from 'react-router-dom'
import BlogFrame from '../components/BlogFrame';
import pfp from "../img/swim.png";

const text = (
  <div>
    <div className="pfp">
      <img className="pfp cursor-help" src={pfp} alt="[Me swimming]" title="Swimming in Oslofjorden" />
    </div>
    <h1>Me</h1>
    <p>I have a B.Sc. degree in Computer Science from University of Turku, a global top 300 university, and the 3rd highest rated in Finland.</p>
    <p>My bachelor thesis was <i>"Koneellinen syväoppiminen: metodit ja arkkitehtuurit" (Deep Learning: Methods and Architectures)</i>. It focused on technical similarities and differences between deep learning methods, and by which key attributes they are usually categorized. It was the first work of its kind in Finnish according to my professor. I had to come up with new Finnish vocabulary for the cutting edge AI my thesis was about during its writing process.</p>
    <p>My true specialization is in software engineering. Easily maintainable code with clear architecture is what I strive for. SOLID and DRY. I have toyed with multiple programmming languages from C++ to Haskell to Clojure, which gives me a wide perspective on software development. My main programming languages are <b>Java</b> and <b>JavaScript</b>, with Python and TypeScript as comfortable auxiliaries.</p>
    <p>I'm occupationally fluent in Finnish and English, have proficiency in Swedish and Norwegian, a conversational grasp of German, and know basic Chinese.</p>
    <p>I'm currently employed at <a href="https://www.vincit.fi/en/" target="_blank" rel="noopener noreferrer">Vincit</a> as a software consultant, working on all kinds of customer projects as full-stack developer, getting to utilize my entire skillstack and beyond which is great. Vincit is as of 2022 certified <a href="https://greatplacetowork.fi/parhaat-tyopaikat/suomen-parhaat-tyopaikat-2022/">the best place to work in Finland.</a></p>
    
    <h2>Portfolio</h2>
    <p>My public code is at <a href="https://github.com/otjura" target="_blank" rel="noopener noreferrer">GitHub</a>.</p>
    <p>My portfolio can be found <Link to="/portfolio">here</Link> on this homepage.</p>

    <h2>Contact</h2>
    <p>You can get in touch with me by sending <a href="mailto:ojrajala@gmail.com">email</a> or connecting with me at <a href="https://www.linkedin.com/in/otsorajala/" target="_blank" rel="noopener noreferrer">LinkedIn</a>. </p> 

    <footer>2022</footer>
  </div>
);

export default function About() {
  return (
    <BlogFrame text={text} />
  );
}